export const GET_ENTITIES_REQUEST = 'GET_ENTITIES_REQUEST';
export const GET_ENTITIES_SUCCESS = 'GET_ENTITIES_SUCCESS';
export const GET_ENTITIES_FAILURE = 'GET_ENTITIES_FAILURE';
export const GET_ENTITY_REQUEST = 'GET_ENTITY_REQUEST';
export const GET_ENTITY_SUCCESS = 'GET_ENTITY_SUCCESS';
export const GET_ENTITY_FAILURE = 'GET_ENTITY_FAILURE';
export const CREATE_ENTITY_REQUEST = 'CREATE_ENTITY_REQUEST';
export const CREATE_ENTITY_SUCCESS = 'CREATE_ENTITY_SUCCESS';
export const CREATE_ENTITY_FAILURE = 'CREATE_ENTITY_FAILURE';
export const UPDATE_ENTITY_REQUEST = 'UPDATE_ENTITY_REQUEST';
export const UPDATE_ENTITY_SUCCESS = 'UPDATE_ENTITY_SUCCESS';
export const UPDATE_ENTITY_FAILURE = 'UPDATE_ENTITY_FAILURE';
export const DELETE_ENTITY_REQUEST = 'DELETE_ENTITY_REQUEST';
export const DELETE_ENTITY_SUCCESS = 'DELETE_ENTITY_SUCCESS';
export const DELETE_ENTITY_FAILURE = 'DELETE_ENTITY_FAILURE';
export const GET_ARTISTS_REQUEST = 'GET_ARTISTS_REQUEST';
export const GET_ARTISTS_SUCCESS = 'GET_ARTISTS_SUCCESS';
export const GET_ARTISTS_FAILURE = 'GET_ARTISTS_FAILURE';
export const GET_ENTITY_GLOBALS_REQUEST = 'GET_ENTITY_GLOBALS_REQUEST';
export const GET_ENTITY_GLOBALS_SUCCESS = 'GET_ENTITY_GLOBALS_SUCCESS';
export const GET_ENTITY_GLOBALS_FAILURE = 'GET_ENTITY_GLOBALS_FAILURE';
export const CLEAR_ENTITY_DATA = 'CLEAR_ENTITY_DATA';

export const clearEntityData = () => ({
  type: CLEAR_ENTITY_DATA,
});

export const getEntitiesRequest = (data) => ({
    type: GET_ENTITIES_REQUEST,
    payload: data,
});
export const getEntitiesSuccess = (data) => ({
    type: GET_ENTITIES_SUCCESS,
    payload: data,
});
export const getEntitiesFailure = (data) => ({
    type: GET_ENTITIES_FAILURE,
    payload: data,
});

export const getEntityRequest = (data) => ({
    type: GET_ENTITY_REQUEST,
    payload: data,
});
export const getEntitySuccess = (data) => ({
    type: GET_ENTITY_SUCCESS,
    payload: data,
});
export const getEntityFailure = (data) => ({
    type: GET_ENTITY_FAILURE,
    payload: data,
});

export const getEntityGlobalsRequest = (data) => ({
    type: GET_ENTITY_GLOBALS_REQUEST,
    payload: data,
});
export const getEntityGlobalsSuccess = (data) => ({
    type: GET_ENTITY_GLOBALS_SUCCESS,
    payload: data,
});
export const getEntityGlobalsFailure = (data) => ({
    type: GET_ENTITY_GLOBALS_FAILURE,
    payload: data,
});

export const getArtistsRequest = (data) => ({
    type: GET_ARTISTS_REQUEST,
    payload: data,
});
export const getArtistsSuccess = (data) => ({
    type: GET_ARTISTS_SUCCESS,
    payload: data,
});
export const getArtistsFailure = (data) => ({
    type: GET_ARTISTS_FAILURE,
    payload: data,
});

export const createEntityRequest = (data) => ({
    type: CREATE_ENTITY_REQUEST,
    payload: data,
});
export const createEntitySuccess = (data) => ({
    type: CREATE_ENTITY_SUCCESS,
    payload: data,
});
export const createEntityFailure = (data) => ({
    type: CREATE_ENTITY_FAILURE,
    payload: data,
});

export const updateEntityRequest = (data) => ({
    type: UPDATE_ENTITY_REQUEST,
    payload: data,
});
export const updateEntitySuccess = (data) => ({
    type: UPDATE_ENTITY_SUCCESS,
    payload: data,
});
export const updateEntityFailure = (data) => ({
    type: UPDATE_ENTITY_FAILURE,
    payload: data,
});

export const deleteEntityRequest = (data) => ({
    type: DELETE_ENTITY_REQUEST,
    payload: data,
});
export const deleteEntitySuccess = (data) => ({
    type: DELETE_ENTITY_SUCCESS,
    payload: data,
});
export const deleteEntityFailure = (data) => ({
    type: DELETE_ENTITY_FAILURE,
    payload: data,
});